export const PERMISSION_KEYS = {
  CUSTOM_WORKFLOW: 'Custom_Workflow',
  STANDARD_WORKFLOW: 'Standard_Workflow'
};
